import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "ShopHome",
      component: () => import("./views/shop/Home.vue")
    },
    {
      path: "/ClassifyHome",
      name: "ClassifyHome",
      component: () => import("./views/classify/Home.vue")
    },
    {
      path: "/CarGoodsQuery",
      name: "CarGoodsQuery",
      component: () => import("./views/car/goods/Query.vue")
    },
    {
      path: "/CarGoodsHome",
      name: "CarGoodsHome",
      component: () => import("./views/car/goods/Home.vue"),
      meta: {
        // 上级页面名称
        // 配置了这个当前页面就会被缓存
        previous: ["ShopHome", "ClassifyHome", "CartTab"],
        title: "车主用品"
      }
    },
    {
      path: "/CarGoodsInfo",
      name: "CarGoodsInfo",
      component: () => import("./views/car/goods/Info.vue"),
      meta: {
        title: "商品详情"
      }
    },
    {
      path: "/CarDrivingList",
      name: "CarDrivingList",
      component: () => import("./views/car/driving/List.vue"),
      meta: {
        previous: ["ShopHome"],
        title: "代驾服务"
      }
    },
    {
      path: "/CarDrivingInfo",
      name: "CarDrivingInfo",
      component: () => import("./views/car/driving/Info.vue"),
      meta: {
        title: "商品详情"
      }
    },
    {
      path: "/CartTab",
      name: "CartTab",
      component: () => import("./views/cart/Tab.vue")
    },
    {
      path: "/CartHome",
      name: "CartHome",
      component: () => import("./views/cart/Home.vue")
    },
    {
      path: "/CartOrderConfirm",
      name: "CartOrderConfirm",
      component: () => import("./views/cart/order/Confirm.vue"),
      meta: {
        title: "确认订单"
      }
    },
    {
      path: "/CartOrderInfo",
      name: "CartOrderInfo",
      component: () => import("./views/cart/order/Info.vue"),
      meta: {
        title: "订单详情"
      }
    },
    {
      path: "/CartOrderGasCouponInfo",
      name: "CartOrderGasCouponInfo",
      component: () => import("./views/cart/order/gasCouponInfo.vue"),
      meta: {
        title: "订单详情"
      }
    },
    {
      path: "/CartOrderAddress",
      name: "CartOrderAddress",
      component: () => import("./views/cart/order/Address.vue"),
      meta: {
        title: "修改收货地址"
      }
    },
    {
      path: "/CartOrderPay",
      name: "CartOrderPay",
      component: () => import("./views/cart/order/Pay.vue"),
      meta: {
        title: "收银台"
      }
    },
    {
      path: "/CartOrderGasCouponConsequence",
      name: "CartOrderGasCouponConsequence",
      component: () => import("./views/cart/order/gasCouponConsequence.vue"),
      meta: {
        title: "支付结果"
      }
    },
    {
      path: "/CartOrderConsequence",
      name: "CartOrderConsequence",
      component: () => import("./views/cart/order/Consequence.vue"),
      meta: {
        title: "支付结果"
      }
    },
    {
      path: "/CartOrderExchange",
      name: "CartOrderExchange",
      component: () => import("./views/cart/order/Exchange.vue"),
      meta: {
        title: "领取使用"
      }
    },
    {
      path: "/UserHome",
      name: "UserHome",
      component: () => import("./views/user/Home.vue")
    },
    {
      path: "/UserLogin",
      name: "UserLogin",
      component: () => import("./views/user/Login.vue")
    },
    {
      path: "/UserSite",
      name: "UserSite",
      component: () => import("./views/user/Site.vue"),
      meta: {
        title: "设置"
      }
    },
    {
      path: "/UserOrder",
      name: "UserOrder",
      component: () => import("./views/user/Order.vue"),
      meta: {
        previous: ["UserHome"],
        title: "我的订单"
      }
    },
    {
      path: "/UserCouponsGas",
      name: "UserCouponsGas",
      component: () => import("./views/user/coupons/gas.vue"),
      meta: {
        title: "加油卡券"
      }
    },
    {
      path: "/UserCouponsHome",
      name: "UserCouponsHome",
      component: () => import("./views/user/coupons/Home.vue"),
      meta: {
        title: "车主卡券"
      }
    },
    {
      path: "/UserIntegral",
      name: "UserIntegral",
      component: () => import("./views/user/Integral.vue"),
      meta: {
        title: "我的车主币"
      }
    },
    {
      path: "/FeePhonePay",
      name: "FeePhonePay",
      component: () => import("./views/fee/phone/Pay.vue"),
      meta: {
        title: "话费充值"
      }
    },
    {
      path: "/UserAddressHome",
      name: "UserAddressHome",
      component: () => import("./views/user/address/Home.vue"),
      meta: {
        previous: ["UserHome", "CartOrderConfirm"],
        title: "我的收货地址"
      }
    },
    {
      path: "/UserPassWord",
      name: "UserPassWord",
      component: () => import("./views/user/PassWord.vue")
    },
    {
      path: "/UserAddressEdit",
      name: "UserAddressEdit",
      component: () => import("./views/user/address/Edit.vue")
    },
    {
      path: "/UserOwnerActivation",
      name: "UserOwnerActivation",
      component: () => import("./views/user/owner/Activation.vue"),
      meta: {
        title: "车主卡激活"
      }
    },
    {
      path: "/Lottery",
      name: "Lottery",
      component: () => import("./views/lottery/Integral.vue"),
      meta: {
        title: "车主抽奖"
      }
    },
    {
      path: "/UserBankHome",
      name: "UserBankHome",
      component: () => import("./views/user/bank/Home.vue"),
      meta: {
        previous: ["MoneyHome"],
        title: "我的银行卡"
      }
    },
    {
      path: "/UserBankSelect",
      name: "UserBankSelect",
      component: () => import("./views/user/bank/Select.vue"),
      meta: {
        previous: ["MoneyExchange"],
        title: "选择银行卡"
      }
    },
    {
      path: "/UserBankEdit",
      name: "UserBankEdit",
      component: () => import("./views/user/bank/Edit.vue"),
      meta: {
        previous: ["UserBankHome", "UserBankSelect"],
        title: "添加银行卡"
      }
    },
    {
      path: "/UserBankInfo",
      name: "UserBankInfo",
      component: () => import("./views/user/bank/Info.vue"),
      meta: {
        title: "添加银行卡"
      }
    },
    {
      path: "/UserMoneyHome",
      name: "UserMoneyHome",
      component: () => import("./views/user/money/Home.vue"),
      meta: {
        previous: ["MoneyHome", "MoneyBalance"],
        title: "交易记录"
      }
    },
    {
      path: "/UserMoneyInfo",
      name: "UserMoneyInfo",
      component: () => import("./views/user/money/Info.vue"),
      meta: {
        title: "交易详情"
      }
    },
    {
      path: "/DealInfo",
      name: "DealInfo",
      component: () => import("./views/deal/Info.vue"),
      meta: {
        title: "协议"
      }
    },
    {
      path: "/CardIdUp",
      name: "CardIdUp",
      component: () => import("./views/card/id/Up.vue"),
      meta: {
        title: "上传身份证"
      }
    },
    {
      path: "/CardBankUp",
      name: "CardBankUp",
      component: () => import("./views/card/bank/Up.vue"),
      meta: {
        title: "上传银行卡"
      }
    },
    {
      path: "/CardBankList",
      name: "CardBankList",
      component: () => import("./views/card/bank/List.vue"),
      meta: {
        title: "支持银行卡列表"
      }
    },
    {
      path: "/MoneyHome",
      name: "MoneyHome",
      component: () => import("./views/money/Home.vue"),
      meta: {
        previous: ["ShopHome"],
        title: "车主币钱包"
      }
    },
    {
      path: "/MoneyCertification",
      name: "MoneyCertification",
      component: () => import("./views/money/Certification.vue"),
      meta: {
        previous: ["MoneyHome"],
        title: "实名认证"
      }
    },
    {
      path: "/MoneyBalance",
      name: "MoneyBalance",
      component: () => import("./views/money/Balance.vue"),
      meta: {
        previous: ["MoneyHome"],
        title: "车主币余额"
      }
    },
    {
      path: "/MoneyExchange",
      name: "MoneyExchange",
      component: () => import("./views/money/Exchange.vue"),
      meta: {
        previous: ["MoneyBalance", "MoneyConsequence"],
        title: "车主币提现"
      }
    },
    {
      path: "/CommonProblem",
      name: "CommonProblem",
      component: () => import("./views/helps/Home.vue"),
      meta: {
        title: "常见问题"
      }
    },
    {
      path: "/MoneyConsequence",
      name: "MoneyConsequence",
      component: () => import("./views/money/Consequence.vue"),
      meta: {
        title: "提现结果"
      }
    },
    {
      path: "/LocationHome",
      name: "LocationHome",
      component: () => import("./views/location/Home.vue")
    },
    {
      path: "/BreakCarHome",
      name: "BreakCarHome",
      component: () => import("./views/break/car/Home.vue"),
      meta: {
        title: "违章查询"
      }
    },
    {
      path: "/BreakCarEdit",
      name: "BreakCarEdit",
      component: () => import("./views/break/car/Edit.vue"),
      meta: {
        title: "爱车档案"
      }
    },
    {
      path: "/BreakList",
      name: "BreakList",
      component: () => import("./views/break/List.vue"),
      meta: {
        title: "违章列表"
      }
    },
    {
      path: "/BreakHistory",
      name: "BreakHistory",
      component: () => import("./views/break/History.vue"),
      meta: {
        title: "历史违章"
      }
    },
    {
      path: "/BreakDrivingHome",
      name: "BreakDrivingHome",
      component: () => import("./views/break/driving/Home.vue"),
      meta: {
        title: "驾照查分"
      }
    },
    {
      path: "/BreakDrivingEdit",
      name: "BreakDrivingEdit",
      component: () => import("./views/break/driving/Edit.vue"),
      meta: {
        title: "添加驾照"
      }
    },
    {
      path: "/FeeOilHome",
      name: "FeeOilHome",
      component: () => import("./views/fee/oil/Home.vue"),
      meta: {
        previous: ["ShopHome"],
        title: "油卡充值"
      }
    },
    {
      path: "/FeeOilExchange",
      name: "FeeOilExchange",
      component: () => import("./views/fee/oil/exchange.vue"),
      meta: {
        previous: ["ShopHome"],
        title: "油卡兑换"
      }
    },
    {
      path: "/feeOilExchangeInfo",
      name: "feeOilExchangeInfo",
      component: () => import("./views/fee/oil/exchangeInfo.vue"),
      meta: {
        title: "商品详情"
      }
    },
    {
      path: "/FeeVipHome",
      name: "FeeVipHome",
      component: () => import("./views/fee/vip/Home.vue"),
      meta: {
        previous: ["ShopHome"],
        title: "会员充值"
      }
    },
    {
      path: "/FeeOilEdit",
      name: "FeeOilEdit",
      component: () => import("./views/fee/oil/Edit.vue"),
      meta: {
        title: "添加油卡"
      }
    },
    {
      path: "/FeeVipPay",
      name: "FeeVipPay",
      component: () => import("./views/fee/vip/Pay.vue")
    },
    {
      path: "/ScooterHome",
      name: "ScooterHome",
      component: () => import("./views/scooter/Home.vue"),
      meta: {
        title: "租车"
      }
    },
    {
      path: "/ScooterOrderConfirm",
      name: "ScooterOrderConfirm",
      component: () => import("./views/scooter/order/Confirm.vue"),
      meta: {
        title: "确认订单"
      }
    },
    {
      path: "/ScooterOrderList",
      name: "ScooterOrderList",
      component: () => import("./views/scooter/order/List.vue"),
      meta: {
        title: "租车订单"
      }
    },
    {
      path: "/ScooterOrderInfo",
      name: "ScooterOrderInfo",
      component: () => import("./views/scooter/order/Info.vue"),
      meta: {
        title: "订单详情"
      }
    },
    {
      path: "/ScooterOrderWait",
      name: "ScooterOrderWait",
      component: () => import("./views/scooter/order/Wait.vue"),
      meta: {
        title: "提交结果"
      }
    },
    {
      path: "/activity",
      name: "activity",
      component: () => import("./views/activity/index.vue"),
      meta: {
        title: "活动"
      }
    },
    {
      path: "/activityover",
      name: "activityover",
      component: () => import("./views/activity/over.vue"),
      meta: {
        title: "活动"
      }
    }
  ]
});
